<div class="connection-status-container pb-1">
  @if(this.isOnline){
    <span class="status-online-icon"></span>
    <span class="status-text">
      {{'::Field:Online' | abpLocalization}}
    </span>
  } @else{
    <span class="status-offline-icon"></span>
    <span class="status-text">
      {{'::Field:Offline' | abpLocalization}}
    </span>
  }
</div>
